import { apiGet } from '../../api'

export const get_program_users = query => {
  return apiGet({
    endpoint: `programs/get_program_users?${query}`
  })
}
